import produce from 'immer';
import {
    SHOW_CONTACT_US,
    SHOW_DELETE_MY_ACCOUNT,
    SHOW_TERMS_OF_USE,
    SHOW_PROFILE
} from 'shared/actions/types';

const initialState = {
    profile: {
        state: '',
        url: ''
    }
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SHOW_TERMS_OF_USE:
            return produce(state, draft => {
                draft.profile.state = SHOW_TERMS_OF_USE;
                draft.profile.url = action.payload;
            });
        case SHOW_CONTACT_US:
            return produce(state, draft => {
                draft.profile.state = SHOW_CONTACT_US;
                draft.profile.url = action.payload;
            });
        case SHOW_DELETE_MY_ACCOUNT:
            return produce(state, draft => {
                draft.profile.state = SHOW_DELETE_MY_ACCOUNT;
                draft.profile.url = action.payload;
            });
        case SHOW_PROFILE:
            return produce(state, draft => {
                draft.profile.state = SHOW_PROFILE;
            });

        default:
            return state;
    }
}